import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';

const CategoryStyles = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 3.5rem;
    font-family: HammersmithOne;
    font-size: 1.8rem;
    /* justify-content: center; */
    

         a {
            display: grid;
            grid-template-columns: auto 1fr;
            grid-gap: 0 1rem;
            align-items: center;
            padding: .5rem;
            margin: 1rem 1.5rem;
            background-color: rgba(0, 0, 0, 0.5);
            background-color: var(--white);
            border: 2px solid rgba(0, 0, 0, .18);
            border-radius: .5rem;
            color: var(--black);
            box-shadow: 0 10px 20px -6px rgba(0,0,0,.5);
            @media (max-width: 650px) {
                margin: .5rem .5rem;
            }

            .count {
                color: var(--black);
                color: var(--grey);
            }

            &[aria-current='page'] {
                background-color: var(--black);
                color: var(--white);
            }
         }
`;

function countProductsInCategories(products) {
    // return the products with counts
    const counts = products
        .map((product) => product.category)
        .flat()
        .reduce((acc, category) => {
            // check if this is an existing category
            const existingCategory = acc[category.id];
            // if it is, increment by 1
            if(existingCategory) {
                existingCategory.count += 1;
            }
            // otherwise create a new entry in our acc and set it to one
            else {
                acc[category.id] = {
                    id: category.id,
                    name: category.name,
                    count: 1
                }
            }
            return acc;
        }, {})
        // sort them based on their count
        const sortedCategories = Object.values(counts).sort((a, b) => b.count - a.count);
        return sortedCategories;
}

export default function CategoriesFilter({ activeCategory }) {
    // get a list of all the categories
    // get a list of all the products with their categories
    const { products } = useStaticQuery(graphql`
        query {
            products: allSanityProduct {
                nodes {
                    category {
                        id
                        name
                    }
                }
            }
        }
    `);
    // count how many products are in each category
    const categoriesWithCounts = countProductsInCategories(products.nodes);
    // loop over the list of categories and display the count of products in the category
    // link it up... 
    return (
        <CategoryStyles className="category__wrapper">
            <Link to={"/products"}>
                <span className="name">All</span>
                <span className="count">{products.nodes.length}</span>
            </Link>
            {categoriesWithCounts.map(category => (
                <Link key={category.id} to={`/category/${(category.name).toLowerCase()}`} className={category.name === activeCategory ? 'active' : ''}>
                    <span className="name">{category.name}</span>
                    <span className="count">{category.count}</span>
                </Link>
            ))}
        </CategoryStyles>
    )
}